import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import ReplayIcon from '@material-ui/icons/Replay';
import { LIVE_CLASSROOM_TABS } from 'constants/index';
import { includes } from 'lodash';
import {
  classroomInsightsStartProcessing,
  useTrackerInstanceSectionClassroomCommonIssues,
  useTrackerInstanceSectionClassroomTomorrowFocus
} from 'sdk';

import BaseBlock from 'pages/LiveClassroom/components/BaseBlock/index';
import CommonIssues from 'pages/LiveClassroom/components/CommonIssues/index';
import StudentDetails from 'pages/LiveClassroom/components/StudentDetails';
import TommorowFocus from 'pages/LiveClassroom/components/TommorowFocus/index';
import { notifyErrors } from 'utils/notifications';

import styles from './style.module.scss';

const RightPanel = ({ celebrationCount, checkInWith, insightsStatus }) => {
  const { trackerInstanceSectionId } = useParams();
  const [isLoadingInsights, setIsLoadingInsights] = useState(false);
  const [isGeneratingAfterError, setIsGeneratingAfterError] = useState(false);

  const handleGenerateInsights = async () => {
    setIsLoadingInsights(true);

    if (insightsStatus === 'error') {
      setIsGeneratingAfterError(true);
    }

    const { success, errors } = await classroomInsightsStartProcessing({
      trackerInstanceSectionId
    });

    if (!success) {
      notifyErrors(errors);
      setIsLoadingInsights(false);
    }
  };

  const {
    data: commonIssues,
    isLoading: isLoadingCommonIssues,
    refetch: refetchCommonIssues
  } = useTrackerInstanceSectionClassroomCommonIssues({
    trackerInstanceSectionId
  });

  const {
    data: tommorowFocus,
    isLoading: isLoadingTomorrowFocus,
    refetch: refetchTomorrowFocus
  } = useTrackerInstanceSectionClassroomTomorrowFocus({
    trackerInstanceSectionId
  });

  useEffect(() => {
    if (insightsStatus !== 'error') {
      setIsGeneratingAfterError(false);
    }

    if (insightsStatus === 'up_to_date' && isLoadingInsights === true) {
      setIsLoadingInsights(false);

      refetchCommonIssues();
      refetchTomorrowFocus();
    }
    if (
      insightsStatus === 'error' &&
      isLoadingInsights === true &&
      !isGeneratingAfterError
    ) {
      setIsLoadingInsights(false);
    }
  }, [
    insightsStatus,
    isLoadingInsights,
    refetchCommonIssues,
    refetchTomorrowFocus,
    isGeneratingAfterError
  ]);

  const disableGenerateButton = includes(
    ['up_to_date', 'not_allowed'],
    insightsStatus
  );
  return (
    <div>
      <button
        className={styles.generateButton}
        onClick={handleGenerateInsights}
        disabled={
          isLoadingInsights || disableGenerateButton || isGeneratingAfterError
        }
      >
        <ReplayIcon /> Generate Insights
      </button>
      {insightsStatus === 'up_to_date' && (
        <div className={styles.insightsText}>
          Insights are up to date with submitted student works
        </div>
      )}

      {insightsStatus === 'error' && (
        <div className={styles.insightsText}>
          There was an error generating insights. Please try again.
        </div>
      )}
      {insightsStatus === 'out_of_date' && (
        <div className={styles.insightsText}>
          New student works have been submitted since the last insights
          generation. Please generate insights to see the latest data.
        </div>
      )}
      {insightsStatus === 'not_allowed' && (
        <div className={styles.insightsText}>
          Insights generation is not allowed for this class.
        </div>
      )}
      <div className={styles.rightPanel}>
        <CommonIssues
          issues={commonIssues}
          isLoading={
            isLoadingInsights ||
            isLoadingCommonIssues ||
            insightsStatus === 'processing'
          }
          noDataAvailable={insightsStatus === 'no_data'}
        />
        <TommorowFocus
          data={tommorowFocus}
          isLoading={
            isLoadingTomorrowFocus ||
            isLoadingInsights ||
            insightsStatus === 'processing'
          }
          checkInWith={checkInWith}
          celebrationCount={celebrationCount}
          noDataAvailable={insightsStatus === 'no_data'}
        />
        {false && (
          <BaseBlock
            title={LIVE_CLASSROOM_TABS.STUDENT_DETAILS}
            icon={<PersonOutlineIcon />}
          >
            <StudentDetails selectedUser={null} />
          </BaseBlock>
        )}
      </div>
    </div>
  );
};

export default RightPanel;
